module.exports = __webpack_public_path__ + "media/images/icons/outlined/question-circle-ca7a6fa2cb2521360b02fe4b3b3620f9.svg";